import {zeroPad} from "../modules/util";

export function makeCalendarMonth(year, month) {
	function compareMonth(lookingPage, date, compareType) {
		let cond;
		if (compareType === "isNext") {
			cond = (date.getFullYear() === Number(lookingPage.year) && date.getMonth() + 1 > Number(lookingPage.month)) ||
				date.getFullYear() > Number(lookingPage.year);
		} else if (compareType === "isPrev") {
			cond = (date.getFullYear() === Number(lookingPage.year) && date.getMonth() + 1 < Number(lookingPage.month)) ||
				date.getFullYear() < Number(lookingPage.year);
		}
		return cond;
	}
	const date = new Date(Number(year), Number(month) - 1, 1);
	firstDateOfWeek(date);
	let week;
	const monthArray = [];

	for (let j = 0; j < 6; j++) {
		if (compareMonth({year: year, month: month}, date, "isNext")) {
			break;
		}
		week = [];
		for (let i = 0 ; i < 7; i++) {
			week.push({
				year: date.getFullYear(),
				month: date.getMonth() + 1,
				date: date.getDate(),
				code: dateFormat(date, "-"),
				isPrevMonth: compareMonth({year: year, month: month}, date, "isPrev"),
				isNextMonth: compareMonth({year: year, month: month}, date, "isNext")
			});
			nextDate(date);
		}
		monthArray.push(week);
	}
	return monthArray;
}

export function makeCalendars(fromYYYYMMDD, toYYYYMMDD) {
	const calendars = [];
	const year = Number(fromYYYYMMDD.slice(0, 4));
	const month = Number(fromYYYYMMDD.slice(4, 6)) - 1;
	const date = new Date(year, month, 1);
	for (; dateFormat(date) <= toYYYYMMDD; updateNextMonth(date)) {
		const year = date.getFullYear();
		const month = date.getMonth() + 1;
		const yyyymm = year + zeroPad(month);
		calendars.push({
			year: year,
			month: month,
			yyyymm: yyyymm,
			weeks: makeCalendarMonth(year, month)
		});
	}
	return calendars;
}

const DAY_MS = 60 * 60 * 24 * 1000;

function firstDateOfWeek(date) {
	// start with Sunday
	date.setTime(date.getTime() - DAY_MS * date.getDay() );
}

function updateNextMonth(date) {
	date.setMonth(date.getMonth() + 1);
}

function nextDate(date) {
	date.setTime(date.getTime() + DAY_MS);
}

function dateFormat(date, delimiter="") {
	return [
		date.getFullYear(),
		zeroPad(date.getMonth() + 1),
		zeroPad(date.getDate())
	].join(delimiter);
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/modules/calendar.js